// extracted by mini-css-extract-plugin
export var button = "_ir-2";
export var card = "_ir-0";
export var closeButtonContainer = "_ir-3";
export var iconContainer = "_ir-1";